import { Link } from 'react-router-dom'
import { Button } from '@bizora/ui'

interface SignupButtonProps {
  mobile?: boolean
  onClick?: () => void
  className?: string
  size?: 'sm' | 'md' | 'lg'
  variant?: 'default' | 'secondary' | 'ghost'
  children?: React.ReactNode
}

export function SignupButton({ 
  mobile = false, 
  onClick, 
  className = '',
  size = 'sm',
  variant = 'default',
  children = 'Get Started'
}: SignupButtonProps) {
  if (mobile) {
    return (
      <Link to="/register" onClick={onClick} className={`w-full mt-2 block ${className}`}>
        <Button 
          className="w-full" 
          size={size}
        >
          {children}
        </Button>
      </Link>
    )
  }

  return (
    <Link to="/register" onClick={onClick}>
      <Button 
        size={size} 
        variant={variant}
        className={className}
      >
        {children}
      </Button>
    </Link>
  )
}

